import React from "react";
import OrderOptions from "./components/Order-OrderOptions";
import OrderContactInfo from "./components/Order-ContactInfo";
import { OrderContext } from "./components/OrderProvider";
import OrderInformation from "./components/Order-Details";
import PopupMessage from "./components/PopupMessage";
import CreateBooking from "./components/CreateBooking";
import ReCAPTCHA from "react-google-recaptcha";
import CreateBookingLoading from "./components/CreateBookingLoading";
export default function MainForm() {
  const formRef = React.useRef();
  // Site key
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [showPopup, setShowPopup] = React.useState(false);
  const [orderId, setOrderId] = React.useState("");
  // This function will handle the form submission
  const [recaptchaVal, setRecaptchaVal] = React.useState(null);
  const { state, dispatch } = React.useContext(OrderContext);
  async function onSubmitBooking(e) {
    e.preventDefault();
    dispatch({ type: "SET_LOADING", value: true });
    dispatch({ type: "SET_LOADING_TEXT", value: "Submitting...." });
    const formData = new FormData(e.target);
    const allEntries = Object.fromEntries(formData.entries());

    // Filter out ReCAPTCHA and other non-form fields
    var data = Object.fromEntries(
      Object.entries(allEntries).filter(
        ([key, value]) =>
          !key.startsWith("g-recaptcha") && // Exclude ReCAPTCHA fields
          key !== "recaptcha" && // Exclude any custom recaptcha fields
          value !== "" // Optionally exclude empty values
      )
    );
    // convert string fields to boolean for boolean type fields
    data.isgeneratepdfticket = data.isgeneratepdfticket === "on" ? true : false;
    // Validate Promo code only if optional. If promo code invalid, dont submit form
    if (data.promo_code) {
      setTimeout(() => {
        dispatch({
          type: "SET_LOADING_TEXT",
          value: "Validating promo code...",
        });
      }, 1000);
      try {
        const promoRes = await fetch(
          `${process.env.REACT_APP_ODATA_BASE_URL}PromoCodes(promoCode='${data.promo_code}')`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (!promoRes.ok) {
          setTimeout(() => {
            dispatch(
              { type: "SET_LOADING", value: false },
              { type: "SET_LOADING_TEXT", value: "" } //set empty
            );
          }, 1000);
          alert("Promo code is invalid!");
          return;
        }
      } catch (error) {
        setTimeout(() => {
          dispatch(
            { type: "SET_LOADING", value: false },
            { type: "SET_LOADING_TEXT", value: "" } //set empty
          );
        }, 1000);
        alert("Something wrong when validating promo code. Please try again");
        return;
      }
    }
    setTimeout(() => {
      dispatch({ type: "SET_LOADING_TEXT", value: "Generating Order ID...." });
    }, 1000);
    const getOrderId = await fetch(
      `${process.env.REACT_APP_ODATA_BASE_URL}GetNextOrderID`
    )
      .then((res) => res.json())
      .then((data) => data.value)
      .catch((error) => {
        alert(
          "Something wrong when generating your Order ID. Please try again"
        );
        throw new Error(
          "Something wrong when generating your Order ID. Please try again"
        );
      });
    if (getOrderId) {
      data.ID = getOrderId;
    } else {
      setTimeout(() => {
        dispatch(
          { type: "SET_LOADING", value: false },
          { type: "SET_LOADING_TEXT", value: "" } //set empty
        );
      }, 1000);
      alert("Something wrong when generating your Order ID. Please try again");
      return;
    }
    // This is the File object (e.g., JPG)
    // Send the data to the server
    try {
      var aDiscountAttachments = [];
      if (e.target.elements.discount_attachment) {
        aDiscountAttachments = e.target.elements.discount_attachment.files;
      }
      // const oDiscountAttachment = discountTypeFile
      //   ? (() => {
      //       const formData = new FormData();
      //       formData.append("file", discountTypeFile);
      //       return formData;
      //     })()
      //   : null;
      const res = await CreateBooking(data, aDiscountAttachments);
      if (res.ok) {
        setOrderId(getOrderId);
        setTimeout(() => {
          dispatch({ type: "SET_LOADING", value: false });
          dispatch(
            { type: "SET_LOADING_TEXT", value: "" } //set empty
          );
          formRef.current.reset();
          dispatch({ type: "RESET_STATE" });
          setShowPopup(true);
        }, 2000);
      } else {
        alert("Error submitting the form. Please try again.");
      }
    } catch (error) {
      alert(
        "Something went wrong while reserving your booking. Please try again later"
      );
      return;
    }
  }

  return (
    <>
      <div className="main-form">
        <form
          ref={formRef}
          onSubmit={onSubmitBooking}
          method="post"
          style={{ overflow: "auto", marginBottom: "100px" }}
        >
          <div style={{ padding: "20px" }}>
            {/* Choice of Orders */}
            <input type="hidden" name="ID" value={orderId} />
            <OrderOptions />
            {/* Order Contact Information */}
            <OrderContactInfo />
            {/* Order Information */}
            <OrderInformation />
          </div>
          <ReCAPTCHA
            sitekey={siteKey}
            onChange={(e) => setRecaptchaVal(e)}
            style={{ paddingLeft: "20px", paddingBottom: "10px" }}
          />
          <div className="main-form-footer">
            <button
              type="submit"
              className="main-form-footer-button"
              disabled={!recaptchaVal}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      {showPopup && (
        <PopupMessage orderId={orderId} onClose={() => setShowPopup(false)} />
      )}
      {state.loading && (
        <CreateBookingLoading loadingText={state.loadingText} />
      )}
    </>
  );
}
